import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../constants';

const getButtonBackgroundColor = (variant, isHovered) => {
  if (isHovered) {
    switch (variant) {
      case 'primary':
        return colors.green40;
      case 'secondary':
        return colors.grey80;
      case 'icon':
        return colors.grey80;
      case 'light':
        return colors.green90;
      default:
        return colors.grey80;
    }
  }
  switch (variant) {
    case 'primary':
      return colors.green;
    case 'secondary':
      return colors.grey90;
    case 'icon':
      return colors.grey90;
    case 'light':
      return colors.white;
    default:
      return colors.grey90;
  }
};

const getButtonColor = variant => {
  switch (variant) {
    case 'primary':
      return colors.white;
    case 'secondary':
      return colors.navy;
    case 'icon':
      return colors.navy;
    case 'light':
      return colors.green;
    default:
      return colors.navy;
  }
};

const getButtonPadding = (size, variant) => {
  if (variant === 'icon') {
    return '6px';
  }
  switch (size) {
    case 'large':
      return '12px 16px';
    case 'medium':
      return '8px 12px';
    case 'small':
      return '4px 16px';
    default:
      return '8px 12px';
  }
};

const getButtonBorderRadius = size => {
  switch (size) {
    case 'large':
      return '6px';
    case 'medium':
      return '4px';
    case 'small':
      return '4px';
    default:
      return '4px';
  }
};

const getButtonHeight = size => {
  switch (size) {
    case 'large':
      return '48px';
    case 'medium':
      return '40px';
    case 'small':
      return '32px';
    default:
      return '40px';
  }
};

const StyledButton = styled.button`
  background-color: ${props => getButtonBackgroundColor(props.variant)};
  color: ${props => getButtonColor(props.variant)};
  padding: ${props => getButtonPadding(props.size, props.variant)};
  border-radius: ${props => getButtonBorderRadius(props.size)};
  height: ${props => getButtonHeight(props.size)};
  margin: 0 10px;
  line-height: 24px;
  font-size: 16px;
  font-family: 'Rubik', sans-serif;
  :hover,
  :active {
    background-color: ${props => getButtonBackgroundColor(props.variant, true)};
  }
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Button = ({ onClick, variant, children, size }) => {
  return (
    <StyledButton size={size} variant={variant} onClick={onClick}>
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'secondary', 'icon', 'light']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  size: PropTypes.oneOf(['large', 'medium', 'small']),
};

Button.defaultProps = {
  onClick: () => {},
};

export default Button;
